export default function Footer() {
  return (
    <footer class="site-footer">
      <div class="container"></div>
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-sm-6 col-xs-12">
            <p class="copyright-text">
              Copyright &copy; Copyright © 2020 Pine Roofing - Miami, FL - Call
              (305)-470-9970
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
